import logo from '../assets/images/logo.png'

const Logo = () => {
    return <img src={logo} alt="HomeData Dashboard" className="logo" />;
}

export default Logo;
